import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2cff95a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "detail-item" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = { class: "table" }
const _hoisted_13 = { width: "83" }
const _hoisted_14 = { width: "83" }
const _hoisted_15 = { width: "83" }
const _hoisted_16 = { width: "83" }
const _hoisted_17 = { width: "83" }
const _hoisted_18 = { width: "83" }
const _hoisted_19 = { width: "83" }
const _hoisted_20 = { width: "83" }
const _hoisted_21 = { width: "83" }
const _hoisted_22 = { width: "83" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice } from '../data_old'
import { useRtfix, isMultiStore } from '@/store'
import { useRouter } from 'vue-router'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props
const router = useRouter()

const jump = () => {
  router.push(useRtfix('ShippingInfo', { query: { deliveryTaskCode: props.rowItemDetail?.deductShipOtherInfoRespDTO?.orderNumber } }))
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('国际发货单号')) + "：", 1),
            (!__props.rowItemDetail.deductShipOtherInfoRespDTO?.orderNumber || __props.rowItemDetail.systemSource === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.rowItemDetail.deductShipOtherInfoRespDTO?.orderNumber ?? '-'), 1))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: jump
                }, _toDisplayString(__props.rowItemDetail.deductShipOtherInfoRespDTO?.orderNumber), 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('国际运单号')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.deductShipOtherInfoRespDTO?.transferNumber ?? '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)()&&__props.rowItemDetail?.currencyCode === 'KRW')), 1)
          ])
        ]),
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(t)('偏远地区费补扣')), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_unref(t)('超长超重费补扣')), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_unref(t)('改派费补扣')), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_unref(t)('扣件费补扣')), 1),
            _createElementVNode("th", _hoisted_17, _toDisplayString(_unref(t)('退件费补扣')), 1),
            _createElementVNode("th", _hoisted_18, _toDisplayString(_unref(t)('销毁费补扣')), 1),
            _createElementVNode("th", _hoisted_19, _toDisplayString(_unref(t)('仓储费补扣')), 1),
            _createElementVNode("th", _hoisted_20, _toDisplayString(_unref(t)('退差价')), 1),
            _createElementVNode("th", _hoisted_21, _toDisplayString(_unref(t)('关税补扣')), 1),
            _createElementVNode("th", _hoisted_22, _toDisplayString(_unref(t)('特殊处理费补扣')), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)('合计2')), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.remoteAreaFeeDiff)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.oversizeweightFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.redistributionFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.fastenerFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.returnFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.destructionFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.storageFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.refundFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.tariffFee)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail.deductShipOtherInfoRespDTO?.specialHandlingFee)), 1),
            _createElementVNode("td", null, _toDisplayString(__props.rowItemDetail.changeType === 1 ? '-' : '+') + " " + _toDisplayString(__props.rowItemDetail.changeAmount ?? 0), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})